import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin: -52px 0 52px;\n  width: 100%;\n  @media screen and (max-width: 375px) {\n    justify-content: space-around;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import { compose } from 'recompose';
import styled, { withTheme } from '../utils/styling/styled-components';
import { RoundActionButton } from '../ActionButton';
import { theme } from '../theme';
var Actions = styled.div(_templateObject());
var enhance = compose(withTheme);
var MobileActions = enhance(function (props) {
  return /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.md - 1
  }, /*#__PURE__*/React.createElement(Actions, {
    className: props.className
  }, props.actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(RoundActionButton, {
      key: index,
      text: action.text,
      icon: action.icon,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText
    });
  })));
});
export { MobileActions };